const sessionValueFields = document.querySelectorAll('form [name="SessionID__c"]');

/**
 * Retrieve the value of a specific cookie by name.
 * @param {string} cookieName - The name of the cookie to retrieve.
 * @returns {string|null} - The cookie value or null if not found.
 */
const getCookieValue = (cookieName) => {
    const cookie = document.cookie
        .split('; ')
        .find((cookie) => cookie.startsWith(`${cookieName}=`));
    return cookie ? decodeURIComponent(cookie.split('=')[1]) : null;
};

if (sessionValueFields.length > 0) {
    const gaCookie = getCookieValue('_ga');
    if (gaCookie) {
        sessionValueFields.forEach((field) => {
            field.value = gaCookie;
        });
    }
}
